import React from 'react';
import { Typography } from '@material-ui/core';
import { createStyles, withStyles } from '@material-ui/core/styles';

/** @component */
export const PrintFooter = withStyles(theme => createStyles({
  footerClass: {
    display: 'none',
    '@media print': {
      bottom: 0,
      left: theme.props.isSafari ? 0 : '',
      position: theme.props.isSafari ? 'absolute' : 'fixed',
      width: '100%',
      display: 'block'
    }
  }
}))(({
  classes,
  patient
}) => /*#__PURE__*/React.createElement("div", {
  className: classes.footerClass
}, /*#__PURE__*/React.createElement(Typography, {
  variant: "caption"
}, patient.firstName, " ", patient.lastName, " (#", patient.patientNumber, ")")));
export default PrintFooter;